function sortLocations(state: ProjectsState, sortProps: SortProps) {
  const { index, sortBy } = sortProps;
  const sortOrder = state.projectsList[sortProps.index].sortOrder;
  const locations = [...state.projectsList[index].locations];
  const lang = 'en';
  const settings = {
    ignorePunctuation: true,
    sensitivity: 'base',
  };

  locations.sort((a, b) => {
    if (sortOrder === 'ascending') {
      return a[sortBy].localeCompare(b[sortBy], lang, settings);
    }
    return b[sortBy].localeCompare(a[sortBy], lang, settings);
  });

  return locations;
}

function sortOrder(state: ProjectsState, sortProps: SortProps) {
  if (state.projectsList[sortProps.index].sortOrder === 'ascending') {
    return 'descending';
  }
  return 'ascending';
}

export default {
  SET_LAST_SEARCHED_VALUE(state: ProjectsState, lastSearchedValue: string) {
    state.lastSearchedValue = lastSearchedValue;
  },
  SET_LAYER_ERROR(state: ProjectsState, errorMessage: string) {
    state.layerError = errorMessage;
  },
  SET_LIST_ERROR(state: ProjectsState, errorMessage: string) {
    state.listError = errorMessage;
  },
  SET_LIST_VIEW_IS_A_TO_Z(state: ProjectsState, listViewIsAToZ: boolean) {
    state.listViewIsAToZ = listViewIsAToZ;
  },
  SET_LOCATION_COORDINATES(state: ProjectsState, locationCoordinates: Coordinates | null) {
    state.locationCoordinates = locationCoordinates;
  },
  SET_PROJECTS_LIST(state: ProjectsState, projectsList: ProjectItem[]) {
    state.projectsList = projectsList;
  },
  SET_PROJECTS_LIST_FILTER(state: ProjectsState, projectsFilter: ProjectFilter) {
    state.projectsFilter = projectsFilter;
  },
  SET_REQUEST_SUMMARY_FLAG(state: ProjectsState, requestSummary: boolean) {
    state.requestSummary = requestSummary;
  },
  SET_SELECTED_FEATURE_SUMMARY(
    state: ProjectsState,
    selectedFeatureSummary: SelectedFeatureSummary,
  ) {
    state.selectedFeatureSummary = selectedFeatureSummary;
  },
  SET_SELECTED_LOCATION(state: ProjectsState, selectedLocation: SelectedLocation) {
    state.selectedLocation = selectedLocation;
  },
  SET_SORT_BY(state: ProjectsState, sortProps: SortProps) {
    state.projectsList[sortProps.index].sortBy = sortProps.sortBy;
    state.projectsList[sortProps.index].sortOrder = sortOrder(state, sortProps);
    state.projectsList[sortProps.index].locations = sortLocations(state, sortProps);
  },
  SET_SUGGESTED_LOCATIONS(state: ProjectsState, suggestedLocations: SuggestedLocation[]) {
    state.suggestedLocations = suggestedLocations;
  },
  SET_SUGGESTIONS_MODEL(state: ProjectsState, suggestionsModel: string) {
    state.suggestionsModel = suggestionsModel;
  },
  SET_SUGGESTED_PROJECTS(state: ProjectsState, suggestedProjects: SuggestedProject[]) {
    state.suggestedProjects = suggestedProjects;
  },
  SET_USER_GUIDE_VISIBILITY(state: ProjectsState, userGuideVisible: boolean) {
    state.userGuideVisible = userGuideVisible;
  },
};
